import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUnlock } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

import styles from './styles.module.scss';
import errorMsg from '../../Functions/errorMsg';
import { MoonLoader } from 'react-spinners';

const SolarEclipseMap = ({ address, city, zipCode }) => {

  const mapContainer = useRef(null);
  const [map, setMap] = useState(null);
  const [center, setCenter] = useState(null);
  const [mapInteractive, setMapInteractive] = useState(false);

  const [loading, setLoading] = useState(false);

  const [eclipseData, setEclipseData] = useState(null);

  useEffect(() => {
    if (loading === true || eclipseData !== null) return;
    let timeoutId;
  
    const fetchCoordinatesWithDelay = async () => {
      setLoading(true);
      try {
        const response = await axios.post(`${window.location.origin}/api/eventHub/eclipseData`, {
          address,
          city,
          zipCode
        });
  
        if (response && response.status === 200) {
          const data = response.data;
          const { center } = data.center;
  
          setCenter(center);
          setEclipseData(data.eclipseData);
        } else {
          errorMsg("Could not locate this location. a");
        }
      } catch (error) {
        errorMsg("Could not locate this location." + error.toString());
      }
      setLoading(false);
    };
  
    // Delay fetch by 500 milliseconds
    timeoutId = setTimeout(fetchCoordinatesWithDelay, 1500);
  
    return () => {
      // Cancel the timeout if the component unmounts or data changes
      clearTimeout(timeoutId);
    };
  }, [address, city, zipCode, eclipseData]);

  useEffect(() => {
    if (!center) return;

    mapboxgl.accessToken = 'pk.eyJ1Ijoid2Fjb2V4Y2hhbmdlIiwiYSI6ImNsdDI3bnFvbTByODQybXF4bnV6eHZvNW0ifQ.b1kQixq2mV4ChcEys0i4XQ';

    const initializedMap = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/wacoexchange/clt29tbhd01w901p471g3hcj3',
      center,
      zoom: 15,
    });
  
    // Custom marker element with SVG
    const markerElement = document.createElement('div');
    markerElement.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#154734bd" stroke="#ffffff67" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"></path>
        <circle cx="12" cy="9" r="2"></circle>
      </svg>
    `;
    markerElement.style.width = '50px';
    markerElement.style.height = '50px';

    new mapboxgl.Marker({ element: markerElement }).setLngLat(center).addTo(initializedMap);

    setMap(initializedMap);

    return () => {
      initializedMap.remove();
    };
  }, [center]);

  useEffect(() => {
    if (map) {
      if (mapInteractive) {
        map.boxZoom.enable();
        map.scrollZoom.enable();
        map.dragPan.enable();
        map.dragRotate.enable();
        map.keyboard.enable();
        map.doubleClickZoom.enable();
      } else {
        map.boxZoom.disable();
        map.scrollZoom.disable();
        map.dragPan.disable();
        map.dragRotate.disable();
        map.keyboard.disable();
        map.doubleClickZoom.disable();
      }
    }
  }, [map, mapInteractive]);

  const toggleMapInteraction = () => {
    setMapInteractive(!mapInteractive);
  };

  const [eclipse, setEclipse] = useState(null);

  useEffect(() => {
    if(eclipseData !== null) {
      if(eclipseData.phenomena[2] === undefined || eclipseData.phenomena[4] === undefined) return;
      console.log(eclipseData);

      const startTime = eclipseData.phenomena[2].time;
      const [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
      const startDay = parseInt(eclipseData.phenomena[1].day, 10)
      const getStartTime = new Date(Date.UTC(2024, 3, startDay, startHours, startMinutes, startSeconds));

      const endTime = eclipseData.phenomena[4].time;
      const [endHours, endMinutes, endSeconds] = endTime.split(':').map(Number);
      const endDay = parseInt(eclipseData.phenomena[1].day, 10)
      const getEndTime = new Date(Date.UTC(2024, 3, endDay, endHours, endMinutes, endSeconds));

      setEclipse({
        start: getStartTime,
        end: getEndTime
      })
    }
  }, [eclipseData])

  return (
    <div id={styles.wrapper}>
      <div id={styles.container}>
        <div ref={mapContainer} style={{ width: '100%' }} />
        { map === null && <div id={styles.floatWrapper} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><MoonLoader size={40} color='white' /></div> }
        { map !== null && <div id={styles.floatWrapper} style={{  }}>
          
          <button id={styles.toggleButton} onClick={toggleMapInteraction}>
              { mapInteractive ? <FontAwesomeIcon icon={faUnlock} id={styles.icon} /> : <FontAwesomeIcon icon={faLock} id={styles.icon} /> }
          </button>
          <div style={{display: eclipse === null ? 'none' : 'flex'}} id={styles.eclipseData}>
            <h1>April 8th, 2024</h1>
            <h2>Totality Starts: <b>{eclipse !== null && eclipse.start.toLocaleString('en-US', { timeZone: 'America/Chicago', hour12: true, hour: 'numeric', minute: '2-digit' })}</b></h2>
            <h2>Totality Ends: <b>{eclipse !== null && eclipse.end.toLocaleString('en-US', { timeZone: 'America/Chicago', hour12: true, hour: 'numeric', minute: '2-digit' })}</b></h2>
          </div>
        </div> }

      </div>
    </div>
  );
};

export default SolarEclipseMap;
